import { render, staticRenderFns } from "./FormCreateOrUpdate.vue?vue&type=template&id=58058d8a&"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports